import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReportJobsService } from '../../../services/report-jobs.service';
import { ReportHubService } from '../../../services/report-hub.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-payment-links-audit-report',
  templateUrl: './payment-links-audit-report.component.html',
  styleUrls: ['./payment-links-audit-report.component.scss']
})
export class PaymentLinksAuditReportComponent implements OnInit, OnDestroy {
  startDate: Date | null = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  endDate: Date | null = new Date();
  loading = false;

  private reportHubSub!: Subscription;
  private pendingJobId: string | null = null;

  constructor(
    private reportJobsService: ReportJobsService,
    private reportHubService: ReportHubService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.reportHubSub = this.reportHubService.reportStatusChanged$.subscribe(notification => {
      if (notification.jobId !== this.pendingJobId) return;

      if (notification.status === 'Completed') {
        this.loading = false;
        this.toastService.showSuccess('Reporte de Links de Pago generado exitosamente. Descargando...');
        this.reportJobsService.downloadReport(notification.jobId, notification.fileName || undefined);
        this.pendingJobId = null;
      } else if (notification.status === 'Failed') {
        this.loading = false;
        this.toastService.showError(`Error al generar el reporte: ${notification.errorMessage || 'Desconocido'}`);
        this.pendingJobId = null;
      } else if (notification.status === 'Processing') {
        this.toastService.showInfo('Procesando reporte de Links de Pago...');
      }
    });
  }

  ngOnDestroy(): void {
    this.reportHubSub?.unsubscribe();
  }

  generateReport(): void {
    if (this.startDate && this.endDate && this.startDate > this.endDate) {
      this.toastService.showWarning('La fecha de inicio no puede ser posterior a la fecha de fin');
      return;
    }

    this.loading = true;
    this.reportJobsService.queuePaymentLinksAuditReport(this.startDate, this.endDate).subscribe({
      next: (response) => {
        this.pendingJobId = response.jobId;
        this.toastService.showInfo('Generando reporte de Links de Pago en segundo plano...');
      },
      error: (error) => {
        console.error('Error requesting Payment Links Audit report:', error);
        this.toastService.showError('Error al solicitar el reporte');
        this.loading = false;
      }
    });
  }
}
